import { PropsWithChildren } from 'react'
import { FC } from 'react'
import {
  StyledClickable,
  StyledClickableProps,
} from '../StyledClickable/StyledClickable'

type ButtonProps = StyledClickableProps &
  PropsWithChildren<{
    disabled?: boolean
    type?: 'button' | 'submit' | 'reset'
  }>

export const Button: FC<ButtonProps> = ({
  children,
  appearance,
  ariaLabel,
  type,
  ...restProps
}) => {
  return (
    <StyledClickable
      appearance={appearance}
      type={type}
      {...restProps}
      aria-label={ariaLabel}
    >
      {children}
    </StyledClickable>
  )
}
